import React from 'react';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { WordShape, UserShape, TackShape, NavigationShape } from '../../shapes';
import WordDefinition from './word_definition';
import Comments from '../../containers/comments';
import Waiting from '../waiting';
import PropTypes from 'prop-types';

export default class WordBody extends React.Component {
  static propTypes = {
    word: WordShape,
    user: UserShape,
    tack: TackShape,
    navigation: NavigationShape,
    loadComments: PropTypes.bool,
    targetLanguage: PropTypes.string
  }

  render() {
    if (this.props.word.get('loading')) {
      return this.renderRetrieving();
    } else if (!this.props.word.get('error')) {
      let cta;
      if (this.props.tack.get('done')) {
        cta = this.renderTackOptions();
      } else if (this.props.tack.get('wordText') && this.props.user.get('loggedIn')) {
        cta = this.renderAlreadyTackingOptions();
      } else {
        cta = this.renderTackOptions();
      }
      return(
        <Fragment>
          <WordDefinition word={ this.props.word } tack={ this.props.tack } targetLanguage={ this.props.targetLanguage } />
          { this.renderWhatYouAreDoing() }
          { cta }
          { this.renderComments() }
        </Fragment>
      );
    } else {
      return null;
    }
  }

  renderComments() {
    if (this.props.loadComments) {
      return (
        <Fragment>
          <div className='give-me-55-top'></div>
          <Comments wordText={ this.props.word.get('wordText') } />
        </Fragment>
      )
    } else return null;
  }

  renderTackOptions() {
    let tackCTAText;
    if (this.props.tack.get('done')) {
      tackCTAText = 'Tack Again';
    } else {
      tackCTAText = 'Start Tacking';
    }

    return (
      <div className='action'>
        <Link to={ this.takeMeBackLink() } className='btn btn-outline-secondary'>Nah</Link>
        <Link to={this.tackLink()} className='btn btn-dark' data-primary-cta='true'>{tackCTAText}</Link>
      </div>
    );
  }

  tackLink() {
    let tackLink;
    const targetLanguage = this.props.targetLanguage || 'en';
    if (this.props.user.get('loggedIn')) {
      tackLink = `/tacks/${this.props.word.get('wordText')}/${targetLanguage}`;
    } else {
      tackLink = `/tacks/logged_out/${this.props.word.get('wordText')}/${targetLanguage}`;
    }
    return tackLink;
  }

  renderWhatYouAreDoing() {
    if (this.props.user.get('loggedIn')) {
      return null;
    } else {
      return (
        <div className='highlight-sandwich'>
          <b><Link to={this.tackLink()} className="link-with-no-border">Start tacking</Link></b> to remember the definition of "{this.props.word.get('wordText')}" the next time you hear it or read it.
        </div>
      );
    }
  }

  renderRetrieving() {
    return(
      <div className='item-meta'>
        <Waiting />
      </div>

    )
  }

  renderAlreadyTackingOptions() {
    return(
      <div className='action'>
        <Link to={ this.takeMeBackLink() } className='btn btn-dark' data-primary-cta='true'>Yep. already tacking</Link>
      </div>
    );
  }

  takeMeBackLink() {
    return this.props.navigation.get('afterTackPathname') || '/';
  }


}



// WEBPACK FOOTER //
// ./src/components/word/word_body.jsx